import { Capacitor } from "@capacitor/core";
import { LOG_LEVEL, Purchases } from "@revenuecat/purchases-capacitor";
import { reactAppStage } from "../../utils/reactAppStage";

export const configureRevenueCat = async (orgid: string) => {
  if (orgid === "__guest__") return;
  if (!orgid) return;
  const plarform = Capacitor.getPlatform();
  if (plarform !== "ios" && plarform !== "android") return;
  console.log("Configuring RevenueCat with orgid:", orgid);

  await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG }); // Enable to get debug logs
  let apiKey = "";
  if (plarform === "android") {
    apiKey = "goog_QlavlkAtiZMfjvvJsoKMjbBpkxa";
  }
  if (plarform === "ios") {
    apiKey = "appl_nkoGbgogNBxjHEKzpHdCjyeMYSZ";
  }
  await Purchases.configure({
    apiKey: apiKey,
  });
  if (!(await Purchases.isAnonymous())) await Purchases.logOut();
  const stage = reactAppStage();
  await Purchases.logIn({ appUserID: orgid + "-|-" + stage });
};
